<template>
  <section class="company-intro">
    <div class="card">
      <p class="eyebrow">Company</p>
      <h1>Eccentric Co., Ltd.</h1>
      <p class="description">
        Eccentric Co., Ltd. is a software company based in the Republic of Korea.<br>
        We develop and operate mobile applications and digital services.
      </p>

      <div class="info-block">
        <h2>Contact</h2>
        <p>Email: <a href="mailto:enqlqkr@eccentricco.com">enqlqkr@eccentricco.com</a></p>
      </div>

      <div class="info-block">
        <h2>Legal Entity</h2>
        <p>Eccentric Co., Ltd.</p>
        <p>Republic of Korea</p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HelloWorld'
})
</script>

<style scoped>
.company-intro {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f7f8fa;
  box-sizing: border-box;
}

.card {
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  padding: 40px 28px;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  text-align: left;
  box-sizing: border-box;
}

.eyebrow {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #666666;
}

h1 {
  margin: 0 0 16px;
  font-size: 32px;
  line-height: 1.2;
  color: #111111;
}

.description {
  margin: 0 0 28px;
  font-size: 17px;
  line-height: 1.7;
  color: #333333;
}

.info-block + .info-block {
  margin-top: 24px;
}

h2 {
  margin: 0 0 10px;
  font-size: 18px;
  color: #111111;
}

p {
  margin: 0;
  font-size: 16px;
  line-height: 1.7;
  color: #444444;
}

a {
  color: #1f5eff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .card {
    padding: 28px 20px;
  }

  h1 {
    font-size: 26px;
  }

  .description,
  p {
    font-size: 15px;
  }
}
</style>
